"use strict";

var processInclude = require("./util");
var productBase = require("./product/base");

$(document).ready(function () {
    processInclude(require("./components/miniCart"));
    processInclude(require("./components/videoControls"));
    productBase.addToCart();

    const $header = $(document).find("header");
    window.addEventListener("scroll", () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerHeight = $header.height();

        if (scrollTop > headerHeight) {
            $header.addClass("fixed");
        } else {
            $header.removeClass("fixed");
        }
    });

    $("body").on("click", ".l-overlay", function (e) {
        e.preventDefault();
        $(".l-overlay").removeClass("l-overlay__active-cart").addClass("d-none");
        $(".minicart-popover").removeClass("show");
    });

    // Mobile burger menu handling
    $("nav .burger").on("click", function (e) {
        e.preventDefault();
        $(this).parent().toggleClass("open");
    });

    $("nav ul li a").on("click", function (e) {
        var $this = $(this);
        $this.parents("nav").removeClass("open");
        $("html, body").animate({
            scrollTop: $($this.attr("href")).offset().top
        }, "slow");
    });

    // Product colors handling
    $(".bl-productpresenter-container").each(function (idx, ctnr) {
        var $ctnr = $(ctnr);
        var $productsCtnr = $ctnr.find(".products-container").get(0);

        // Default active color
        var $activeColor = $ctnr.find(".colors svg.active");
        $productsCtnr.style.setProperty("--active-color", $activeColor.attr("data-color"));
        // Active product
        $ctnr.find(".products .product-container[data-color='" + $activeColor.attr("data-color") + "']").addClass("active");
        $ctnr.find(".products-container .caracteristics .experience-caracteristics .experience-bl_assets-caracteristic:first-child .caracteristic-container").addClass("active");

        // Product caracteristics on click
        $ctnr.find(".products-container .products .caracteristic-container .point").on("click", function (e) {
            var $this = $(this);
            var componentId = $this.parent().attr("data-id");
            $(".products-container .caracteristics .caracteristic-container").removeClass("active");
            $(".caracteristic-container[data-id='" + componentId + "']").toggleClass("active");
        });

        // On change of color
        var $svgs = $ctnr.find(".colors svg");
        $svgs.on("click", function (e) {
            $svgs.removeClass("active");
            var $this = $(this);
            $this.addClass("active");
            $productsCtnr.style.setProperty("--active-color", $this.attr("data-color"));

            // Active product
            $ctnr.find(".products .product-container").removeClass("active");
            $ctnr.find(".products .product-container[data-color='" + $this.attr("data-color") + "']").addClass("active");
        });
    });

    // Carousel handling
    initializeCarousel(".gallery");

    // Form submit
    $(".form-container form button[type='submit']").on("click", function (e) {
        e.preventDefault();
        var $this = $(this).parents("form");

        $this.find(".message.success").addClass("hidden");
        $this.find(".message.error").addClass("hidden");
        $this.find(".message.requirederror").addClass("hidden");

        var allRequiredValid = $this.find("input").toArray().every(function (input) {
            var $input = $(input);
            return !$input.prop("required") || ($input.prop("required") && $input.val() !== undefined && $input.val() !== "");
        });
        if (!allRequiredValid) {
            $this.find(".message.requirederror").removeClass("hidden");
            return;
        }

        $this.find("button[type='submit']").prop("disabled", true);
        var formData = new FormData($this[0]);
        $.ajax({
            url: $this.attr("action"),
            type: $this.attr("method"),
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                $this.find("button[type='submit']").prop("disabled", false);
                if (data.success) {
                    $this.find(".message.success").removeClass("hidden");
                    $this.find(".message.error").addClass("hidden");
                    $this.find(".message.requirederror").addClass("hidden");
                } else {
                    $this.find(".message.success").addClass("hidden");
                    $this.find(".message.error").removeClass("hidden");
                    $this.find(".message.requirederror").addClass("hidden");
                }
            }
        });
    });

    $(".backinstockform button[type='submit']").on("click", function (e) {
        e.preventDefault();
        var $this = $(this).parents("form");
        $this.find(".feedback").addClass("hidden");
        var $privacyCheckbox = $this.find(".process-customer-data");
        var $email = $this.find(".bis-subscription__email").val();

        if (!$privacyCheckbox.prop("checked") || $email === "") {
            return;
        }

        $this.find("button[type='submit']").prop("disabled", true);
        var url = $this.attr("action") + "&email=" + $email;
        $.ajax({
            url: url,
            success: function (data) {
                $this.find(".feedback").removeClass("hidden").html(data.msg);
                $this.find("button[type='submit']").prop("disabled", false);
            }
        });
    });

    $(".c-product-tile__swatch-link").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $parent = $this.closest(".product-tile-inner");
        var $swatchLink = $parent.find(".c-product-tile__swatch-link");
        var $swatchImg = $parent.find(".c-product-tile__swatch");
        var $productImage = $this.find(".c-product-tile__swatch");
        var clickedColorValue = $productImage.attr("data-attr-value");
        var $targetProductTile = $parent.find(".product-tile-variant[data-color-value='" + clickedColorValue + "']");
        var $targetSwatchImg = $targetProductTile.find(".c-product-tile__swatches .c-product-tile__swatch[data-attr-value='" + clickedColorValue + "']");

        $parent.find(".product-tile-variant").removeClass("selected");
        $swatchLink.removeClass("selected");
        $swatchImg.removeClass("selected");

        $this.addClass("selected");
        $targetProductTile.addClass("selected");
        $targetSwatchImg.closest("a").addClass("selected");
        $targetSwatchImg.addClass("selected");
    });
});

/**
 * Initializes a carousel component for a specified selector, allowing for interactive navigation
 * through a set of cards using GSAP for animations. The carousel automatically adjusts its layout
 * on window resize and provides "Next" and "Prev" buttons for navigation.
 *
 * @param {string} selector - A CSS selector string that identifies the carousel container element.
 *                            This container should include a list of cards and optional navigation buttons.
 *
 * The function performs the following operations:
 * - Checks if the specified selector exists in the document. If not, it exits early.
 * - Converts the list of cards within the carousel into an array for easy manipulation.
 * - Sets up an event listener to adjust card positions when the window is resized.
 * - Defines a function to update the positions, scales, and z-indexes of the cards to create a
 *   visually appealing carousel effect, with the central card being the largest and most prominent.
 * - Initializes the carousel by setting the initial positions of the cards.
 * - Adds click event listeners to the "Next" and "Prev" buttons to allow users to navigate through
 *   the carousel. The "Next" button moves the carousel forward, while the "Prev" button moves it backward.
 *
 * The carousel uses GSAP (GreenSock Animation Platform) for smooth animations when transitioning
 * between card positions. The animation duration and easing function are configurable within the
 * `gsap.to` method calls.
 *
 * Note: Ensure that GSAP and jQuery are included in your project for this function to work correctly.
 */
function initializeCarousel(selector) {
    if (!document.querySelector(selector)) {
        return;
    }

    const cards = gsap.utils.toArray(selector + " .cards li");
    let currentIndex = 0; // Index de l'image centrale
    let resizedFinished;

    $(window).on("resize", function () {
        clearTimeout(resizedFinished);
        resizedFinished = setTimeout(function () {
            updateCardPositions();
        }, 250);
    });

    function updateCardPositions() {
        let centeredIndex = Math.floor(cards.length / 2);
        let newOrder = [];

        // Réorganiser les cartes pour obtenir l'ordre souhaité
        for (let i = 0; i < cards.length; i++) {
            let index = (currentIndex + i - centeredIndex + cards.length) % cards.length;
            newOrder[index] = cards[i];
        }

        // Mettre à jour les positions des cartes
        newOrder.forEach((card, i) => {
            let offset = i - centeredIndex;
            let spacingX1 = card.offsetWidth * 0.5;
            let spacingX2 = card.offsetWidth * 0.55;
            let xPosition = offset * (card.offsetWidth - (i === centeredIndex ? 0 : (i === 1 || i === 3 ? spacingX1 : spacingX2)));
            let yPosition = (0 + (i === centeredIndex ? 0 : (i === 1 || i === 3 ? 20 : 40)));

            gsap.to(card, {
                x: xPosition,
                y: yPosition,
                scale: i === centeredIndex ? 1 : (i === 1 || i === 3 ? 0.83 : 0.62),
                zIndex: i === centeredIndex ? 15 : (i === 1 || i === 3 ? 10 : 5),
                autoAlpha: 1,
                ease: "power3",
                duration: 0.5
            });
        });
    }

    // Initialisation du carrousel
    updateCardPositions();

    // Inverser le sens de défilement pour les boutons Next et Prev
    const $next = document.querySelector(selector + " .next");
    if ($next) {
        $next.addEventListener("click", () => {
            // Maintenant, "Next" fait avancer le carrousel
            currentIndex = (currentIndex - 1 + cards.length) % cards.length;
            updateCardPositions();
        });
    }

    const $prev = document.querySelector(selector + " .prev");
    if ($prev) {
        $prev.addEventListener("click", () => {
            // Et "Prev" fait reculer le carrousel
            currentIndex = (currentIndex + 1) % cards.length;
            updateCardPositions();
        });
    }
}
